export default {
    methods: {
        punctualStateCss (state) {
            switch (state) {
                case 'upcoming':
                    return 'text-grey-darker bg-grey-lighter'
                case 'due':
                case 'sent':
                    return 'text-yellow-darker bg-yellow-lighter'
                case 'late':
                    return 'text-red-darker bg-red-lighter'
                case 'written_off':
                    return 'text-grey-darker bg-grey-lightest'
                case 'completed':
                case 'accepted':
                    return 'text-green-darker bg-green-lighter'
                default:
                    return 'text-grey-darker bg-grey-lighter'
            }
        },
        activeStateCss (state) {
            if (state === true) {
                return 'text-green-darker bg-green-lighter'
            }

            return 'text-grey-darker bg-grey-lighter'
        },
        paymentIntentStatusCss (status) {
            switch (status) {
                case 'requires_authentication':
                case 'requires_confirmation':
                case 'requires_payment_method':
                case 'requires_capture':
                    return 'text-yellow-darker bg-yellow-lighter'
                case 'failed':
                    return 'text-red-darker bg-red-lighter'
                case 'succeeded':
                    return 'text-green-darker bg-green-lighter'
                default:
                    return 'text-grey-darker bg-grey-lighter'
            }
        }
    }
}
